module.exports = __webpack_public_path__ + "img/anasayfa-urun-bg-bez.0655fe65.png";